import * as React from 'react'

interface Config {
  oldThing: string
  newThing: string
  link: string
}

/* HOOK */

export const useDeprecation = ({ oldThing, newThing, link }: Config) =>
  React.useLayoutEffect(() => {
    if (['test', 'development'].indexOf(process.env.NODE_ENV || '') >= 0) {
      console.warn(
        `${oldThing} is deprecated please use ${newThing}`,
        link && `${link}`
      )
    }
  }, [])

/* DECORATOR */

export const withDeprecation = (config: Config) => (Component: any) => (
  props: any
) => {
  useDeprecation(config)

  return <Component {...props} />
}
